import { HttpService } from 'src/api/common/HttpService';
import { UrlService } from 'src/api/common/UrlService';
import { ApiStatus } from 'src/constants/ApiStatus';
import { CteApiUrl } from 'src/constants/BaseUrls';

type ResponseType = {
  sourceSessionId: number | string;
};

export const ResponseService = () => {
    const { HttpGet, HttpPost, HttpDelete } = HttpService();

    const GetResponseAll = async (body: any) => {
    const suffix = UrlService.BuildQuery(body);
    const url = `${CteApiUrl}/api/v1/response${suffix}`;
    const response = await HttpGet(url);
    return response;
  };

    const GetResponseBySourceId = async (body: ResponseType) => {
    const suffix = UrlService.BuildQuery(body);
    const url = `${CteApiUrl}/api/v1/response/detail${suffix}`;
    const response = await HttpGet(url);
    return response;
  };

    const CreateOrUpdateResponse = async (body: any) => {
    const url = `${CteApiUrl}/api/v1/response/detail`;
    const response = await HttpPost(url, body);
    return response;
  };

    const LogicDeleteResponseById = async (body: ResponseType) => {
    const suffix = UrlService.BuildQuery(body);
    const url = `${CteApiUrl}/api/v1/response/detail/delete${suffix}`;
    const response = await HttpDelete(url);
    return response;
  };

  return {
    GetResponseAll,
    GetResponseBySourceId,
    CreateOrUpdateResponse,
    LogicDeleteResponseById
  };
}
